import React from 'react';

export const StagingBanner: React.FC = () => {
  // Only show on staging domain
  const isStaging = window.location.hostname === 'staging.briefcaseai.org';

  if (!isStaging) return null;

  return (
    <div className="bg-orange-500 text-white text-center py-2 px-4 text-sm font-medium">
      🚧 STAGING ENVIRONMENT - For Testing Only
    </div>
  );
};